import type { TOC } from '@ember/component/template-only';

import styles from './loading-bar.module.css';

interface GeneralLoadingBarSignature {
  Args: {};
  Element: HTMLDivElement;
}

const LoadingBar = <template>
  <div class={{styles.bar}} ...attributes></div>
</template> satisfies TOC<GeneralLoadingBarSignature>;

export default LoadingBar;
